import { useNavigate } from "react-router-dom";
import ManageGLAccountMastForm from "components/ui/ManageGLAccountMastForm";

export default function CreateAccountMaster() {
  const navigate = useNavigate();

  const handleSubmit = (formData) => {
    console.log("Form submitted with data:", formData);
    // TODO: Implement actual form submission logic
    // For now, just log the data and navigate back
    navigate("/gl-accounts-master");
  };

  const handleCancel = () => {
    navigate("/gl-accounts-master");
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      {/* Header */}
      <div className="sm:flex sm:items-center mb-6">
        <div className="sm:flex-auto">
          <h1 className="font-semibold leading-6 text-3xl text-gray-900">
            Create New Account Master
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            Create a new general ledger account master record.
          </p>
        </div>
      </div>

      {/* Form */}
      <ManageGLAccountMastForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isLoading={false}
      />
    </div>
  );
} 